module.exports = __webpack_public_path__ + "img/LINE_logo.37b0675d.png";